module.exports = __webpack_public_path__ + "static/img/emotes.d79afa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/twitch/emotes.png
// module id = TQ0l
// module chunks = 35